var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWriteEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline-2",
    "data-name": "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,12a1,1,0,0,0,1,1H45a1,1,0,0,0,0-2H19A1,1,0,0,0,18,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,31a1,1,0,0,0,0-2H19a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,21.83l-4.12-2.69,6.43-6.44a3.84,3.84,0,1,0-5.42-5.41L53,9.59V5a3,3,0,0,0-3-3H36a1,1,0,0,0,0,2H50a1,1,0,0,1,1,1v6.59l-5.54,5.54A.91.91,0,0,0,45,17H19a1,1,0,0,0,0,2H43.59l-3.3,3.29A1.8,1.8,0,0,0,40,23H19a1,1,0,0,0,0,2H39.28l-1.23,3.68A1,1,0,0,0,39.32,30l6-2a2,2,0,0,0,.39-.24L51,22.41v9.8L40.73,41.36l-2.95-2.52a8.72,8.72,0,0,0-11.56,0l-2.9,2.56L13,32.21V5a1,1,0,0,1,1-1H28a1,1,0,0,0,0-2H14a3,3,0,0,0-3,3V18.3L5.54,21.88A9,9,0,0,0,2,29.05V53a9.06,9.06,0,0,0,9.05,9H53a9.06,9.06,0,0,0,9-9V29.05A9,9,0,0,0,58.4,21.83ZM56.71,8.71c2.07-2.08,4.66.53,2.58,2.59l-.29.29L56.41,9ZM55,10.41,57.59,13,45,25.59,42.41,23Zm-14.42,17,.86-2.57,1.71,1.71ZM53,20.69l4.24,2.77a7.07,7.07,0,0,1,1.62,1.75L53,30.43ZM6.7,23.51,11,20.69v9.74L5.13,25.21A6.68,6.68,0,0,1,6.7,23.51ZM4,53V29.05a6.93,6.93,0,0,1,.28-1.93l7,6.25h0l10.52,9.36L5.44,57.2A7,7,0,0,1,4,53Zm7.05,7a7,7,0,0,1-4.18-1.39L27.54,40.34a6.74,6.74,0,0,1,8.93,0l21,18A7,7,0,0,1,53,60Zm49-7a7,7,0,0,1-1.17,3.88L42.26,42.67,59.72,27.12A6.93,6.93,0,0,1,60,29.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 3,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWriteEmail);
export default __webpack_public_path__ + "static/media/icon-write-email.3383d6e84676ac84d011c1e23edc1784.svg";
export { ForwardRef as ReactComponent };